import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

export const StyledNav = styled.nav`
  background-color: ${({ theme }) => theme.component.rail.backgroundColor};
  border: ${({ theme }) => theme.component.rail.border};
  border-radius: ${({ theme }) => theme.border.radius.lg};
  padding: ${({ theme }) => theme.component.rail.padding};
  width: 250px;
  height: fit-content;
  margin-top: ${({ theme }) => theme.spacing[60]};
  box-shadow: ${({ theme }) => theme.elevation.bottom.sm};
`

export const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[10]};
`

export const NavItem = styled.li`
  margin: 0;
`

export const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[30]};
  padding: ${({ theme }) => `${theme.spacing[30]} ${theme.spacing[40]}`};
  text-decoration: none;
  color: ${({ theme }) => theme.component.rail.linkColor};
  background-color: transparent;
  border-radius: ${({ theme }) => theme.border.radius.md};
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  font-size: ${({ theme }) => theme.typography.body.size.sm};
  font-family: ${({ theme }) => theme.typography.body.family};
  transition: all 0.2s ease-in-out;
  border: 1px solid transparent;

  &:hover {
    background-color: ${({ theme }) => theme.component.rail.linkHover.backgroundColor};
    color: ${({ theme }) => theme.component.rail.linkHover.color};
  }

  &.active {
    background-color: ${({ theme }) => theme.component.rail.linkHover.backgroundColor};
    color: ${({ theme }) => theme.component.rail.linkHover.color};
    font-weight: ${({ theme }) => theme.typography.weight.semibold};
    border-color: ${({ theme }) => theme.palette.primary.default};
  }

  &:focus {
    outline: ${({ theme }) => theme.component.interaction.focus.outline};
    outline-offset: ${({ theme }) => theme.component.interaction.focus.outlineOffset};
  }
`

export const NavIcon = styled.span`
  font-size: ${({ theme }) => theme.typography.body.size.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing[60]};
  height: ${({ theme }) => theme.spacing[60]};
`

export const NavLabel = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`